import {
  IconButton,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from '@chakra-ui/react'
import { useState } from 'react'
import { Icons } from '../icons'
import { UseFormRegister } from 'react-hook-form'

const PasswordInput = ({
  inputStyles,
  register,
  regName,
  formType,
}: {
  inputStyles: InputProps
  register: UseFormRegister<any>
  regName: string
  formType: 'login' | 'signup'
}) => {
  const [show, setShow] = useState(false)
  const handleClick = () => setShow(!show)

  return (
    <InputGroup>
      <Input
        type={show ? 'text' : 'password'}
        autoComplete='off'
        {...inputStyles}
        {...register(regName, {
          required: 'This field is required',
          minLength: {
            value: formType == 'login' ? 4 : 8,
            message:
              formType == 'login'
                ? 'Minimum length should be 4 characters'
                : 'Minimum length should be 8 characters',
          },
          pattern: {
            value:  formType == 'login'?/^.*$/:/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&_])[A-Za-z\d@$!%*#?&_]{8,}$/,
            message:
              'Password must be at least 8 characters long, contain one number, one special character and one alphabet',
          },
        })}
      />
      <InputRightElement>
        <IconButton
          onClick={handleClick}
          variant={'ghost'}
          icon={
            !show ? (
              <Icons.eye width={20} height={20} />
            ) : (
              <Icons.eyeOff width={20} height={20} />
            )
          }
          aria-label={show ? 'Hide password' : 'Show password'}
        />
      </InputRightElement>
    </InputGroup>
  )
}

export default PasswordInput
